import React from "react";
import heartLoading from "../../../assests/heartLoading.gif";

const ContractDetailsContent = ({
  contractDetails,
  contractLoading,
}) => {
  // Function to render frequency details based on frequency type
  const renderFrequencyDetails = () => {
    if (!contractDetails) return null;

    const frequency = contractDetails.frequency;
    const time = contractDetails.time;
    const daysOfWeek = contractDetails.daysOfWeek;
    const dayOfMonth = contractDetails.dayOfMonth;
    const selectedPeriods = contractDetails.selectedPeriods;

    // Consolidated helper to format comma-separated values
    const formatCommaSeparatedValue = (value) => {
      if (!value || value === "") return "N/A";
      if (Array.isArray(value)) return value.join(", ");
      if (typeof value === "string") {
        return value
          .split(",")
          .map((item) => item.trim())
          .join(", ");
      }
      return value;
    };

    // Shared config for periodic frequencies (Quarter, Year, Half-Yearly)
    const periodicFrequencyConfig = [
      { label: "Frequency", value: frequency || "N/A" },
      { label: "Periods", value: formatCommaSeparatedValue(selectedPeriods) },
      { label: "Day of Period", value: dayOfMonth || "N/A" },
      { label: "Time", value: time ? `${time} UTC` : "N/A" },
    ];

    const frequencyConfig = {
      Hourly: [{ label: "Frequency", value: frequency || "N/A" }],
      Daily: [
        { label: "Frequency", value: frequency || "N/A" },
        { label: "Time", value: time ? `${time} UTC` : "N/A" },
      ],
      Weekly: [
        { label: "Frequency", value: frequency || "N/A" },
        { label: "Days of Week", value: formatCommaSeparatedValue(daysOfWeek) },
        { label: "Time", value: time ? `${time} UTC` : "N/A" },
      ],
      "Mars Periodic": [
        { label: "Frequency", value: frequency || "N/A" },
        { label: "Day", value: dayOfMonth || "N/A" },
        { label: "Time", value: time ? `${time} UTC` : "N/A" },
      ],
      "Mars Quarter": periodicFrequencyConfig,
      "Mars Year": periodicFrequencyConfig,
      "Mars Half-Yearly": periodicFrequencyConfig,
    };

    const fieldsToDisplay = frequencyConfig[frequency] || [
      { label: "Frequency", value: frequency || "N/A" },
    ];

    return (
      <div className="grid grid-cols-2 gap-4">
        {fieldsToDisplay.map((field, index) => (
          <div key={index} className="bg-gray-50 p-4 rounded-lg">
            <div className="text-sm text-gray-600 mb-1">{field.label}</div>
            <div className="text-base font-semibold text-gray-900">
              {field.value}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderQualityDimensions = () => {
    if (!contractDetails) return null;

    const dimensions = [
      { name: "Completeness", value: contractDetails.completeness },
      { name: "Accuracy", value: contractDetails.accuracy },
      { name: "Consistency", value: contractDetails.consistency },
      { name: "Freshness", value: contractDetails.freshness },
      { name: "Uniqueness", value: contractDetails.uniqueness },
      { name: "Validity", value: contractDetails.validity },
    ];

    return (
      <div className="grid grid-cols-6 gap-4">
        {dimensions.map((dimension, index) => (
          <div className="text-center p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 mb-1">{dimension?.name}</p>
            <p className={`text-xl font-bold ${dimension.value !== null ? 'text-green-600' : 'text-gray-400'}`}>
              {dimension.value !== null ? `${dimension.value}%` : 'N/A'}
            </p>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      {contractLoading ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <img
              src={heartLoading}
              alt="Loading..."
              className="h-30  mx-auto mb-4"
            />
            <p className="text-gray-700 text-[20px] text-center">
              Loading contract details...
            </p>
          </div>
        </div>
      ) : contractDetails ? (
        <div className="space-y-8">
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
              <div className="w-[5px] h-6 bg-green-600 rounded mr-3"></div>
              Promised Data Quality Dimension
            </h3>
            {renderQualityDimensions()}
          </div>
          {/* DQ Check Frequency Section */}
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
              <div className="w-[5px] h-6 bg-purple-600 rounded mr-3"></div>
              Frequency
            </h3>
            {renderFrequencyDetails()}
          </div>
        </div>
      ) : (
        <div className="text-center py-12">
          <div className="text-gray-400 mb-4">
            <svg
              className="mx-auto h-16 w-16"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
          <p className="text-gray-600 text-lg">
            No contract details available
          </p>
        </div>
      )}
    </div>
  );
};

export default ContractDetailsContent;